<template>
    <div class="ticket-second-search-bar-left">
        <div class="blocks">
            <div v-show="filtersLoader" class="filters-loader">
                <base-loader size="50" weight="3"/>
            </div>

            <filters-block empty
                           v-if="showDateTableBySettings"
                           @toggle="toggleDateTable($event)"
                           :open="showFilters[0]"
                           :title="localizeList.datesTable">
            </filters-block>

            <price-filter v-if="!getWindowSettings.hideTicketPriceRangeFilter"
                          @toggle="scroll"
                          :rate="rate"
                          :open="showFilters[1]"
                          :availability-price="availabilityPrice"
                          :tickets-price-limit="ticketsPriceLimit"
                          :default-air-filter="defaultAirFilter"
                          :localize-list="localizeList"/>

            <filters-block v-if="!getWindowSettings.hideTicketFlightFilter"
                           parent
                           @toggle="scroll"
                           :open="showFilters[2]"
                           :title="localizeList.flightUpper2">

                <flight-class class="sub-block"
                              @toggle="scroll"
                              :open="showFlightFilters[0]"
                              :tickets-class-list="ticketsClassList"
                              :tickets-class-checked="ticketsClassChecked"
                              :tickets-class-multy="ticketsClassMulty"
                              :localize-list="localizeList"/>

                <directs class="sub-block"
                         @toggle="scroll"
                         :open="showFlightFilters[1]"
                         :tickets-transplantation-list="ticketsTransplantationList"
                         :localize-list="localizeList"/>

                <time-filter class="sub-block"
                             @toggle="scroll"
                             :open="showFlightFilters[2]"
                             :arrival-time="arrivalTime"
                             :departure-time="departureTime"
                             :localize-list="localizeList"/>

                <departure-airport class="sub-block"
                                   @toggle="scroll"
                                   :open="showFlightFilters[3]"
                                   :tickets-departure-airports-checked="ticketsDepartureAirportsChecked"
                                   :tickets-departure-list="ticketsDepartureList"
                                   :localize-list="localizeList"/>

                <arrival-airport class="sub-block"
                                 @toggle="scroll"
                                 :open="showFlightFilters[4]"
                                 :tickets-arrival-airports-checked="ticketsArrivalAirportsChecked"
                                 :tickets-arrival-list="ticketsArrivalList"
                                 :localize-list="localizeList"/>

                <airlines class="sub-block"
                          @toggle="scroll"
                          :open="showFlightFilters[5]"
                          :tickets-airline-list="ticketsAirlineList"
                          :tickets-airlines-checked="ticketsAirlinesChecked"
                          :tickets-airline-multy="ticketsAirlineMulty"
                          :localize-list="localizeList"/>

            </filters-block>
        </div>

        <div class="apply-block">
            <base-button @click.native="clearAllFilters"
                         size="15"
                         padding="8px"
                         background="var(--lighten-6-color)"
                         color="#727272">
                {{localizeList.resetFlightsUpper}}
            </base-button>

            <base-button v-if="useApplyFiltersButton"
                         @click.native="applyAllChanges"
                         class="ml-5"
                         size="15"
                         padding="8px"
                         :disabled="doneBtnDisabled">
                {{localizeList.applyUpper}}
            </base-button>
        </div>
    </div>
</template>

<script>
    import FiltersBlock from "../../tour/secondFilters/leftFilters/filtersBlock";
    import PriceFilter from "./priceFilter";
    import FlightClass from "./flightClass";
    import Directs from "./directs";
    import TimeFilter from "./timeFilter";
    import DepartureAirport from "./departureAirport";
    import ArrivalAirport from "./arrivalAirport";
    import Airlines from "./airlines";

    import { bus } from "../../../main"
    export default {
        name: "ticketsSecondSearchBarLeft",
        components: {
            Airlines,
            ArrivalAirport,
            DepartureAirport,
            TimeFilter,
            Directs,
            FlightClass,
            PriceFilter,
            FiltersBlock,
        },
        props: {
            showDateTableBySettings: {
                type: Boolean,
                default: false
            },
            rate: {
                type: Object,
                required: true
            },
            availabilityPrice: {
                type: Array,
                required: true
            },
            ticketsPriceLimit: {
                type: Array,
                required: true
            },
            defaultAirFilter: {
                type: Array,
                required: true
            },
            ticketsClassList: {
                type: Array,
                required: true
            },
            ticketsClassChecked: {
                type: Object,
                required: true
            },
            ticketsClassMulty: {
                type: Object,
                required: true
            },
            ticketsTransplantationList: {
                type: Array,
                required: true
            },
            departureTime: {
                type: Array,
                required: true
            },
            arrivalTime: {
                type: Array,
                required: true
            },
            ticketsDepartureList: {
                type: Array,
                required: true
            },
            ticketsDepartureAirportsChecked: {
                type: Object,
                required: true
            },
            ticketsArrivalList: {
                type: Array,
                required: true
            },
            ticketsArrivalAirportsChecked: {
                type: Object,
                required: true
            },
            ticketsAirlineList: {
                type: Array,
                required: true
            },
            ticketsAirlinesChecked: {
                type: Object,
                required: true
            },
            ticketsAirlineMulty: {
                type: Object,
                required: true
            },
            doneBtnDisabled: {
                type: Boolean,
                required: true
            },
            fixedFilters: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                showFilters: [0, 0, 0],
                showFlightFilters: [0, 0, 0, 0, 0, 0],
                showDateTable: false,
                filtersLoader: false,
            }
        },
        computed: {
            getWindowSettings() {
                return window.settings;
            },
            useApplyFiltersButton() {
                return this.$store.getters['getSettings'].UseApplyFiltersButton;
            }
        },
        created() {
            window.addEventListener("scroll", this.scroll);
        },
        mounted() {
            this.showFilterBySettings()
            this.openAllFilters()
        },
        methods: {
            openAllFilters(){
                const hasSetting = this.getWindowSettings.showAllVerticalFilters

                if(hasSetting){
                    this.showFilters = this.showFilters.map((_, idx) => !idx ? 0 : 1)
                    this.showFlightFilters = this.showFlightFilters.map(() => 1)
                }
            },
            scroll() {
                const isTicket = this.$route.fullPath.includes("Individuals/Avia");
                if (!isTicket) return;

                const dateTable = document.querySelector(".date-filter");
                const leftFilters = document.querySelector(".ticket-second-search-bar-left");
                const resultContent = document.querySelector(".result-content");

                const leftFiltersMarginX = 60;

                if (dateTable) {
                    dateTable.style.marginLeft = leftFilters.offsetWidth + leftFiltersMarginX + 16 + "px";
                }

                leftFilters.style.position = "relative";
                leftFilters.style.top = "unset";

                if (dateTable) {
                    leftFilters.style.position = "absolute";
                }
                resultContent.style.marginLeft = "0";

                if (dateTable)
                    resultContent.style.marginLeft = leftFilters.clientWidth + leftFiltersMarginX + "px";
            },
            applyAllChanges() {
                this.filtersLoader = true;
                this.$emit("apply", [false, () => {
                    this.filtersLoader = false;

                    this.$nextTick(() => {
                        bus.$emit('fixed-filters', this.fixedFilters);
                        bus.$emit("ticket_fixed_filters", this.fixedFilters);
                        this.scroll();
                    })
                }]);
            },
            clearAllFilters() {
                this.$emit("clearAllFilters");
            },
            showFilterBySettings() {
                const settings = this.$store.getters['getSettings'];
                let type = window.settings.ticketAdditionalFilterOpen !== undefined ? window.settings.ticketAdditionalFilterOpen : settings.ExtraFilterToShowInAviaBooking;
                type = type < 4 && type > 0 ? type : null;

                if (type === 1 && !this.showDateTableBySettings) return;

                this.$set(this.showFilters, type-1, this.showFilters[type-1] + 1);

                if (type === 1) this.toggleDateTable(true);
                // if (type === 2) this.scroll();
            },
            toggleDateTable(val) {
                this.showDateTable = val;

                this.$nextTick(() => {
                    this.scroll();
                });

                if (!val) return;

                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        },
        watch: {
            async showDateTable(val) {
                this.$emit('toggleDateTable', val);

                await this.$nextTick();

                const ticketResult = document.querySelector(".result-content");
                const secondSearchBarLeft = document.querySelector(".ticket-second-search-bar-left");

                ticketResult.style.marginLeft = val ? secondSearchBarLeft.clientWidth + 60 + "px" : 0;
            },
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.scroll)
        }
    }
</script>

<style scoped>
    .ticket-second-search-bar-left {
        position: relative;
        margin: 18px 0 18px 60px;
        min-width: 375px;
        max-width: 375px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        align-self: flex-start;
        z-index: 10;
    }

    .ticket-second-search-bar-left .blocks {
        /*overflow-y: scroll;*/
        overflow-x: hidden;
        /*position: relative;*/
    }

    .ticket-second-search-bar-left .blocks .filters-loader {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(200, 200, 200, .5);
    }

    .ticket-second-search-bar-left .filters-block {
        border-top: 1px solid var(--lighten-4-color);
    }

    .sub-block /deep/ .header {
        padding-left: 40px;
    }

    .apply-block {
        padding: 20px;
        background-color: var(--white-color);
        display: flex;
        justify-content: flex-end;
    }
</style>